import React from 'react'
import { Box } from '@hub/box'
import { LocationDropPinMediumIcon } from '@hub/icon'
import { Stack } from '@hub/stack'
import { Text } from '@hub/text'

type CentreSelectorTriggerProps = {
  country: 'Australia' | 'New Zealand'
  onClick: () => void
}

export const CentreSelectorTrigger: React.FC<CentreSelectorTriggerProps> = ({
  country,
  onClick,
}) => {
  return (
    <Stack
      direction="row"
      gap="spacing-sm"
      align="center"
      shouldWrapChildren={false}
    >
      <LocationDropPinMediumIcon boxSize="size-icon-sm" sx={{ flexGrow: 0 }} />
      <Text
        tone="strong"
        fontSize={['font-body', 'font-xl']}
        sx={{ flexGrow: 0 }}
      >
        {country}
      </Text>
      <Box onClick={onClick} sx={{ flexGrow: 0 }}>
        <Text
          decoration="underline"
          fontSize={['font-sm', 'font-body']}
          sx={{ flexGrow: 0, cursor: 'pointer' }}
        >
          Select a centre instead
        </Text>
      </Box>
    </Stack>
  )
}
